import React, {useEffect, useState} from 'react';
import cookie from 'react-cookies';
import {Provider} from 'react-redux';
import {useRouter} from 'next/router';
import NotificationContainer from 'react-notifications/lib/NotificationContainer';
import {initializeStore, useStore} from '../store/store';
import Header from '../components/Header/Header';
import AuthSidebar from '../components/AuthSidebar/AuthSidebar';
import Router from 'next/router';
import Footer from '../components/Footer/Footer';

import 'react-notifications/lib/notifications.css';
import '../styles/global.sass';
import pageLoadingActions from '../store/actions/pageLoadingActions';
import AuthProvider from '../components/AuthProvider';
import translationActions from '../store/actions/language';
import authActions from '../store/actions/authActions';
import CabinetHeaderMobile from '../components/Cabinet/CabinerHeader/CabinetHeaderMobile';
import App from "next/app";
import cookies from 'next-cookies';
import {protectedRoutes} from '../constants/protectedRoutes';
import {locales} from '../constants/locales';

export let reduxStateWithTranslations;

const MyApp = ({Component, pageProps, err}) => {
    const store = useStore({
        ...(pageProps?.initialReduxState || {}),
        ...(pageProps?.appInitialReduxState || {}),
    });

    if (typeof window === 'undefined') {
        reduxStateWithTranslations = pageProps?.appInitialReduxState || {};
    }

    const route = useRouter();

    // eslint-disable-next-line no-unused-vars
    const [isAuthSidebar, toggleAuthSidebar] = useState(false);

    // eslint-disable-next-line no-unused-vars
    const toggleSidebar = (sidebarState) => {
        document.body.style.overflow = isAuthSidebar ? 'scroll' : 'hidden';

        //toggleAuthSidebar(sidebarState);
    };

    useEffect(() => {
        route.events.on('routeChangeStart', () => {
            store.dispatch(pageLoadingActions.setIsPageLoading(true));
        });
        route.events.on('routeChangeComplete', () => {
            store.dispatch(pageLoadingActions.setIsPageLoading(false));
        });
        route.events.on('routeChangeError', () => {
            store.dispatch(pageLoadingActions.setIsPageLoading(false));
        });

        return () => {
            route.events.off('routeChangeStart', () => {
            });
            route.events.off('routeChangeComplete', () => {
            });
            route.events.off('routeChangeError', () => {
            });
        };
    }, [route, store]);

    useEffect(() => {
        if (pageProps?.appInitialReduxState?.language?.language) {
            cookie.save('lang_market', pageProps.appInitialReduxState.language.language, { path: '/', maxAge: (Date.now() / 1000) + (60 * 60 * 24 * 365) });
        }
    }, []);

    if (pageProps?.widgetLayout) {
        return (
            <Provider store={store}>
                <AuthProvider>
                    <Component {...pageProps} err={err}/>
                </AuthProvider>
            </Provider>
        );
    }

    return (
        <Provider store={store}>
            <AuthProvider>
                <Header
                    isSidebar={isAuthSidebar}
                    toggleSidebar={toggleSidebar}
                />
                <CabinetHeaderMobile/>
                <AuthSidebar
                    isSidebar={isAuthSidebar}
                    toggleSidebar={toggleSidebar}
                />
                <Component {...pageProps} err={err}/>
                <Footer/>
                <NotificationContainer/>
            </AuthProvider>
        </Provider>
    );
};

MyApp.getInitialProps = async (appContext) => {
    const {ctx, router} = appContext;
    const {res, pathname} = ctx;
    const token = cookies(appContext.ctx).access_token;
    const state = initializeStore();
    let notAuthenticated = false;

    await Promise.all([
        state.dispatch(translationActions.setLanguage(locales[router.locale] || process.env.DEFAULT_LANG || 'en-US')),
        state.dispatch(translationActions.getLanguageList()),
        state.dispatch(translationActions.getTranslations())
    ]);

    if (token) {
        await state.dispatch(authActions.signIn({token})).then(response => {
            if (!response.data?.data?.access_token || !response.data?.data?.token_bit_team) {
                notAuthenticated = true;
            }
        }).catch(() => {
            notAuthenticated = true;
        });
    } else {
        await state.dispatch(authActions.signOut());
        notAuthenticated = true;
    }

    if (notAuthenticated && protectedRoutes.indexOf(pathname) !== -1) {
        if (typeof window === 'undefined') {
            res.writeHead(302, { Location: `${process.env.PATH_PREFIX}` });
            res.end();
            return {};
        }

        Router.push('/');
        return {};
    }

    const appProps = await App.getInitialProps(appContext);

    appProps.pageProps = Object.assign(appProps.pageProps, {
        appInitialReduxState: {language: state.getState().language, auth: state.getState().auth},
    });

    return appProps;
}

export default MyApp;
